<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'

import Footer from '@/components/Footer/Footer.vue'
import Card from '@/components/ui/Card.vue'
import ContentBody from '@/components/ui/ContentBody.vue'
import ContentHeader from '@/components/ui/ContentHeader.vue'
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'
import Tag from '@/components/ui/tag/Tag.vue'
import { RouterLink } from 'vue-router'

const step = computed(() => {
	return crumbs.value.length - 1
})

const { crumbs, children, name, registry } = useLayoutCrud()

function useLayoutCrud() {
	const { currentRoute } = useRouter()
	const { name, path } = currentRoute

	const registry = computed(() => {
		return ['/inventario/', '/florestal/'].some((layer) =>
			currentRoute.path.toLocaleLowerCase().includes(layer),
		)
	})

	const florestal = computed(() => {
		return currentRoute.path.toLocaleLowerCase().includes('/florestal/')
	})

	const crumbs = computed(() => {
		const pathArray = path.split('/').filter((crumb) => crumb != '')
		pathArray.splice(pathArray.length - 1, 1, name)

		return pathArray.map((crumb, index) => {
			return {
				name: crumb
					.replace('Inventario', 'Inventário')
					.replace('inventario', 'inventário')
					.replace('configuracoes', 'configurações')
					.replace('Configuracoes', 'configurações'),
				step: index,
			}
		})
	})

	const florestalChildren = computed(() => {
		return [
			{ name: 'Fazenda', path: '/Cadastro/Florestal/Fazenda' },
			{ name: 'Floresta', path: '/Cadastro/Florestal/Floresta' },
			{ name: 'Espécie', path: '/Cadastro/Florestal/Especie' },
			{ name: 'Feição', path: '/Cadastro/Florestal/Feicao' },
		]
	})

	const inventarioChildren = computed(() => {
		return [
			{ name: 'Estrato Florestal', path: '/Cadastro/Inventario/EstratoFlorestal' },
			{ name: 'Medição', path: '/Cadastro/inventario/Medicao' },
			{ name: 'Unidade Amostral', path: '/Cadastro/inventario/UnidadeAmostral' },
			{ name: 'Categoria de Árvore', path: '/Cadastro/inventario/CategoriaDeArvore' },
			{ name: 'Equações', path: '/Cadastro/inventario/Equacoes' },
		]
	})

	const children = computed(() => {
		return florestal.value ? florestalChildren.value : inventarioChildren.value
	})

	return { crumbs, children, name, registry, currentRoute }
}
</script>

<template>
	<div class="flex justify-center flex-col">
		<ContentHeader>
			<Breadcrumb
				v-model="step"
				:icon="false"
				:crumbs="crumbs"
				class="breadcrumb__internal flex justify-start"
			/>
		</ContentHeader>
		<ContentBody>
			<Card class="card">
				<div
					v-if="registry"
					class="flex gap-4 justify-end"
				>
					<RouterLink
						v-for="child in children"
						:key="child.name"
						:to="child.path"
					>
						<Tag
							class="py-0.5"
							:disabled="child.disabled"
							:active="name === child.name"
						>
							{{ child.name }}
						</Tag>
					</RouterLink>
				</div>
				<slot />
			</Card>
			<div class="flex gap-2 text-gray-dark">
				<Footer />
			</div>
		</ContentBody>
	</div>
</template>

<style scoped>
.card {
	@apply p-20 bg-white w-full;
}

.active {
	@apply border-blue-600;
}
</style>
